import { module } from 'angular';

import { ArmorySlaShimComponentOptions } from './shim.controller';

import { PLATFORM_SLA_CONFIG } from '../../config/SlaConfig';


export const ARMORY_SLA_CONFIG_SHIM = 'armory.sla.config.shim';

module(ARMORY_SLA_CONFIG_SHIM, [
  PLATFORM_SLA_CONFIG
])
  .component('armorySlaConfigShim', new ArmorySlaShimComponentOptions());
